import React, { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import AtmDetailsView from "./AtmDetailsView";

// Component for rendering ATM view form
const AtmView = () => {
  // Initialize GridStack layout system on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Define grid layout configuration with header and ATM details sections
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader title={"View ATM Details"} showIconsForback={true} />
      ), // Header component with back navigation
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 1,
      component: <AtmDetailsView />, // Main ATM details display component
    },
  ];

  return (
    // Main grid container with GridStack styling classes
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />{" "}
      {/* Renders grid items based on layout configuration */}
    </div>
  );
};

export default AtmView;
